"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProducts = void 0;
var _react = require("react");
var _productsContext = require("../../context/productsContext");
const useProducts = () => {
  const context = (0, _react.useContext)(_productsContext.productsContext);
  if (context) {
    return context;
  }
  throw new Error('Value for `productsContext` must be set.');
};
exports.useProducts = useProducts;
